export default "__VITE_ASSET__B2zhjC3C__"